import SideBar from './SideBar.js';
import SideBarMobile from './SideBarMobile.js';
import styles from './index.module.css';

function Main({ children, pageName }) {
    return (
        <div className={styles.pageContainer}>
            <div className={styles.sideBar}>
                <SideBar />

            </div>
            <div className={styles.sideBarMobile}>
                <SideBarMobile />

            </div>
            <div className={styles.contentContainer}>
                <div >{children}</div>
            </div>
        </div>
    );
}

export default Main;
